import { h } from 'preact';
import PropTypes from 'prop-types';

import Parsely from '../../containers/parsely/parsely';
import {
  parselyMyLocalNewsActions,
  parselyMyLocalNewsStore,
} from '../../../global-store/subjects/parsely/my-local-news';
import { parselyCommonActions, parselyCommonStore } from '../../../global-store/subjects/parsely-common';
import { useSubscribe } from '../../hooks/use-subscribe';
import { renderInRail } from '../../containers/parsely/renderers/render-in-rail';
import { useEffectsInRail } from '../../containers/parsely/use-effects-in-rail';

const IN_GRID_POSITION = 'in-grid';

export const ParselyComponent = ({ $root, htmlProps, widget }) => {
  const state = useSubscribe(parselyMyLocalNewsStore);
  const parselyCommonState = useSubscribe(parselyCommonStore);
  const actions = { ...parselyMyLocalNewsActions, ...parselyCommonActions };
  return (
    <Parsely
      htmlProps={htmlProps}
      widget={widget}
      $root={$root}
      state={state}
      parselyCommonState={parselyCommonState}
      actions={actions}
      render={htmlProps.position === IN_GRID_POSITION ? () => {} : renderInRail}
      useEffects={htmlProps.position === IN_GRID_POSITION ? () => {} : useEffectsInRail}
    />
  );
};

ParselyComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
